<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-card
          id="cardDashbord"
          class="mx-auto"
          outlined
        >
          <div class="card-header-dashbord">
            Última sincronização
          </div>
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div
                  id="idTable"
                  style="overflow-x: auto;"
                >
                  <table
                    style="width: 100%; color: black; border-collapse: collapse;"
                    class="elevation-1"
                    mobile-breakpoint="0"
                  >
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Banco de dados
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Versão
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Tipo
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Status
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Data
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                          class="black--text title"
                        >
                          Intervalo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dadosUltimaSincronizacao"
                        :key="item.id"
                      >
                        <td
                          id="dataAtualizacao"
                          class="text-left"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.nomeBd }}
                        </td>
                        <td
                          id="dataAtualizacao"
                          class="text-right"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.versao }}
                        </td>
                        <td
                          id="dataAtualizacao"
                          class="text-left"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.tipo }}
                        </td>
                        <td
                          id="dataAtualizacao"
                          class="text-left"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.status }}
                        </td>
                        <td
                          id="dataAtualizacao"
                          class="text-left"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.dataultimasincronizacao }}
                        </td>
                        <td
                          id="dataAtualizacao"
                          class="text-right"
                          :style="item.status === 'Sincronizando' ? styleObjectSincronizando : item.sincronizacao ? styleObject : ''"
                        >
                          {{ item.tempoSincronizacao }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../services/utils'
  import Dashboard from '../../services/login'
  import eventEmit from './components/core/EventoEmit'

  export default {
    name: 'DashboardDashboard',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('./components/core/Snackbar'),
    },
    mixins: [utils],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
    },
    data: vm => ({
      appOnline: navigator.onLine,
      nomeUsuario: localStorage.nome,
      snackbar: {
        visible: false,
        color: 'success',
        message: '',
        timeout: 3000,
      },
      styleObject: {
        background: '#ffaaaa',
      },
      styleObjectSincronizando: {
        background: '#B9F6CA',
      },
      corPrimaria: localStorage.corPrimaria,
      user: [],
      loading: false,
      headers: [
        { text: 'Banco de dados', value: 'nomeBd', width: '20%', align: 'left', class: 'pa-1 black--text title' },
        { text: 'Versão', value: 'versao', width: '10%', align: 'left', class: 'pa-1 black--text title' },
        { text: 'Tipo', value: 'tipo', width: '20%', align: 'left', class: 'pa-1 black--text title' },
        { text: 'Status', value: 'status', width: '20%', align: 'left', class: 'pa-1 black--text title' },
        { text: 'Data', value: 'dataultimasincronizacao', width: '25%', align: 'left', class: 'pa-3 black--text title' },
        { text: 'Intervalo', value: 'tempoSincronizacao', width: '25%', align: 'center', class: 'pa-1 black--text title' },
      ],
      dadosUltimaSincronizacao: [],
      sincronizacao: false,
      dynamicPadding: '',
      expandOnHover: true,
      texto: 'Seja bem vindo ' + localStorage.nome,
    }),

    computed: {
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      eventEmit.$emit('atualizar_texto', this.texto)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      Dashboard.showUltimaSincronizacao(localStorage.tokencontrato).then(resposta => {
        if (resposta.data.status) {
          this.styleObject.background = '#ffaaaa'

          this.dadosUltimaSincronizacao = resposta.data.ultimaSincronizacao
        } else if (resposta.data.msg === 'Dados Ultima sincronização não encontrada') {
          this.showSnackbar('error', 3000, resposta.data.msg)
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1380) {
          this.dynamicPadding = 'padding-right: 38rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPadding = 'padding-right: 10rem !important'
        } else {
          this.dynamicPadding = 'padding-right: 30rem !important'
        }
      },

      logout () {
        Dashboard.logout(localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            localStorage.removeItem('username')
            localStorage.removeItem('email')
            localStorage.removeItem('nome')
            localStorage.removeItem('usuarioIdentificado')
            localStorage.removeItem('userUsername')
            localStorage.removeItem('userId')

            this.$router.push('/login')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.message === 'Usuário não encontrado') {
            this.showSnackbar('error', 3000, 'Usuário não encontrado')
          } else if (e.data.message === 'Contrato não encontrato') {
            this.showSnackbar('error', 3000, 'Contrato não encontrato')
          }
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },

  }
</script>

<style scoped>
  #dataAtualizacao {
    font-size: 11px;
  }

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #listItemDashboard {
    margin: -2rem 0 0 -1.2rem;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #dataAtualizacao {
      font-size: 9px;
    }

    #idTable {
      max-height: 500px;
      max-width: 90vw !important;
    }

    th, td {
      padding: 8px;
    }
  }

</style>
